import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { format } from "date-fns";
import { Calendar, Clock } from "@phosphor-icons/react";

import { Avatar, AvatarGroup, Button, FormControl, Stack, Tooltip } from "@mui/material";
import getAvatarInitials from "utils/getAvatarInitials";
import { BILLING_TYPES } from "@constants";

const CallNotStartedDialog = (props) => {
  const {
    sessionDetails,
    open,
    callNotStartedReason,
    onChangeCallNotStartedReason,
    onSubmitCallNotStartedReason,
  } = props;
  const {
    billing_type,
    client_name,
    client_id,
    scheduled_date,
    clinician_avatar,
    clinician_name,
    clinician_id,
    call_duration,
  } = sessionDetails;
  const start = new Date(scheduled_date);
  const end = new Date(start.getTime() + call_duration * 60000);
  const serviceName = BILLING_TYPES[billing_type];
  const eventAttendees = [
    {
      id: client_id,
      name: client_name,
      avatar: null,
    },
    {
      id: clinician_id,
      name: clinician_name,
      avatar: clinician_avatar,
    },
  ];

  return (
    <Dialog maxWidth="sm" open={open}>
      <DialogTitle>Incomplete Appointment</DialogTitle>
      <DialogContent>
        <Stack rowGap={5} pt={7}>
          <Typography component="p" variant="body1">
            We can see that the appointment never began. Confirm the details of the appointment
            below.
          </Typography>
          <Stack
            direction={{ xs: "column" }}
            rowGap={2}
            p={6}
            sx={{ backgroundColor: "#F6F7F8", borderRadius: "16px" }}
          >
            <AvatarGroup max={3} sx={{ justifyContent: "flex-end" }}>
              {eventAttendees.map((attendee) => (
                <Tooltip key={attendee.id} title={attendee.name} arrow placement="top">
                  <Avatar
                    alt={attendee.name}
                    src={attendee.avatar}
                    sx={{ width: 32, height: 32, fontSize: "12px" }}
                    data-testid={`avatar-item-${attendee.id}`}
                  >
                    {getAvatarInitials(attendee.name)}
                  </Avatar>
                </Tooltip>
              ))}
            </AvatarGroup>

            <Typography component="h3" variant="h3" sx={{ mt: 2 }}>
              {serviceName} with {client_name}
            </Typography>

            <Stack
              direction={{ sm: "row" }}
              columnGap={7}
              rowGap={2}
              alignItems={{ xs: "flex-start" }}
            >
              <Typography component="p" variant="body1" color="text.secondary">
                <span style={{ verticalAlign: "bottom", lineHeight: "1" }}>
                  <Clock size={20} weight="duotone" />
                </span>{" "}
                {format(start, "h:mm")} - {format(end, "p")}
              </Typography>

              <Typography
                component="p"
                variant="body1"
                color="text.secondary"
                textTransform="capitalize"
              >
                <span style={{ verticalAlign: "middle", lineHeight: "1" }}>
                  <Calendar size={20} weight="duotone" />
                </span>{" "}
                {format(start, "EEEE, MMMM do")}
              </Typography>
            </Stack>
          </Stack>

          <FormControl>
            <RadioGroup
              aria-label="callNotStartedReason"
              name="callNotStartedReason"
              value={callNotStartedReason}
              onChange={(e) => onChangeCallNotStartedReason(e)}
            >
              <FormControlLabel
                value={"cancel"}
                control={<Radio color="primary" size="small" />}
                label={<Typography>The appointment was canceled</Typography>}
              />
              <FormControlLabel
                value={"no-show"}
                control={<Radio color="primary" size="small" />}
                label={<Typography>Mark the client as a no-show</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={onSubmitCallNotStartedReason}
          disabled={!callNotStartedReason}
        >
          {callNotStartedReason == "no-show" ? "Finish" : "Next"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CallNotStartedDialog;
